import GenericPage from '@/views/GenericPage.vue'
import HomePage from '@/views/illustration/HomePage.vue'
import sgs from '@/data/home-style-galleries.js'

const illustrators = [
  {
    path: '/',
    name: 'illustrators home page',
    component: HomePage,
    alias: ['/us','/br','/cn','/sx','/de','/fr','/sg','/in','/au']
  },
  {
    path: '/login',
    name: 'admin login',
    component: () => import(/* webpackChunkName: "dev" */ '@/views/AdminLogin.vue')
  },
  {
    path: '/admin/signin-return',
    name: 'signin return',
    component: () => import(/* webpackChunkName: "dev" */ '@/views/admin/SigninReturn.vue')
  },
  {
    path: '/admin/signout-return',
    name: 'signout return',
    component: () => import(/* webpackChunkName: "dev" */ '@/views/admin/SignoutReturn.vue')
  },
  {
    path: '/test',
    component: () => import(/* webpackChunkName: "dev" */ '@/views/test-pages/TestPage.vue')
  },
  {
    path: '/not-found',
    name: 'not found',
    component: () => import(/* webpackChunkName: "general" */ '@/views/NotFound.vue')
  },
  {
    path: '/:lang?/artists',
    component: () => import(/* webpackChunkName: "illustrators" */ '@/views/illustration/ArtistContainer.vue'),
    children: [
      {
        path: '/:lang?/artists',
        name: 'illustrators a-z',
        component: () => import(/* webpackChunkName: "illustrators" */ '@/views/illustration/AllArtists.vue')
      },
      {
        path: '/:lang?/artists/:name',
        name: 'illustration portfolio',
        component: () => import(/* webpackChunkName: "illustrators" */ '@/views/illustration/Portfolio.vue'),
        props: true
      },
      {
        path: '/:lang?/artists/:name/videos',
        name: 'portfolio videos container',
        component: () => import(/* webpackChunkName: "illustrators" */ '@/views/illustration/PortfolioVideoNews.vue'),
        props: true,
        children: [
          {
            path: '/:lang?/artists/:name/videos',
            name: 'portfolio videos',
            component: () => import(/* webpackChunkName: "illustrators" */ '@/views/portfolio/VideoPortfolio.vue'),
          },
          {
            path: '/:lang?/artists/:name/news',
            name: 'portfolio news',
            component: () => import(/* webpackChunkName: "illustrators" */ '@/views/portfolio/NewsPortfolio.vue'),
          }
        ]
      },
      {
        path: '/:lang?/artists/:name/:imageid',
        name: 'Single Image View',
        component: () => import(/* webpackChunkName: "illustrators" */ '@/views/illustration/ImagePage.vue'),
        props: true
      }
      
    ]
  },
  {
    path: '/:lang?/styles/:url',
    name: 'illustrator style gallery',
    component: () => import(/* webpackChunkName: "illustrators" */ '@/views/illustration/StyleGallery.vue'),
    props: true
  },
  {
    path: '/:lang?/styles',
    redirect: () => {
      return sgs.getRandomGallery(false)
    }
  },
  {
    path: '/:lang?/applications',
    name: 'artist applications',
    component: () => import(/* webpackChunkName: "general" */ '@/views/ApplicationForm.vue')
  },
  {
    path: '/:lang?/applications/thanks',
    name: 'applications/thanks',
    component: GenericPage
  },
  {
    path: '/:lang?/disclaimer',
    name: 'disclaimer',
    component: GenericPage
  },
  {
    path: '/:lang?/terms',
    name: 'terms',
    component: GenericPage
  },
  {
    path: '/:lang?/privacy-policy',
    name: 'privacy',
    component: GenericPage
  },
  
  {
    path: '/about',
    component: () => import(/* webpackChunkName: "general" */ '@/StyleBrowseNav.vue'),
    children: [
      {
        path: '/:lang?/about',
        name: 'about us',
        component: () => import(/* webpackChunkName: "general" */ '@/views/about/AboutUs.vue'),
      },
      {
        path: '/:lang?/commissioning',
        name: 'commissioning',
        component: () => import(/* webpackChunkName: "general" */ '@/views/CommissioningPage.vue')
      },
      {
        path: '/:lang?/ten-million-trees',
        name: 'ten million trees',
        component: () => import(/* webpackChunkName: "general" */ '@/views/TenMillionTrees.vue')
      },
      {
        path: '/:lang?/contact/:region',
        name: 'contact',
        component: () => import(/* webpackChunkName: "contact" */ '@/views/Contact.vue'),
        props: true
      },
      {
        path: '/:lang?/change-password',
        name: 'changepass',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/ChangePassword.vue')
      },
      {
        path: '/:lang?/password-reset',
        name: 'resetpass',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/ResetPassword.vue')
      },
      {
        path: '/:lang?/forgot-password',
        name: 'forgot password',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/ForgotPass.vue')
      },
      {
        path: '/:lang?/confirm-signup',
        name: 'confirm',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/ConfirmPage.vue')
      },
      {
        path: '/:lang?/my-area/collections',
        name: 'collections index',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/CollectionsPage.vue')
      },
      {
        path: '/:lang?/my-area/collections/view',
        name: 'collection view',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/CollectionView.vue')
      },
      {
        path: '/:lang?/my-area/account',
        name: 'myarea account',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/AccountPage.vue')
      },
      {
        path: '/:lang?/my-area/signup',
        name: 'myarea signup',
        component: () => import(/* webpackChunkName: "myarea" */ '@/views/myarea/SignupPage.vue')
      }
    ]
  },
  {
    path: '/:lang?/vacancies',
    name: 'vacancies',
    component: () => import(/* webpackChunkName: "general" */ '@/views/VacancyView.vue')
  },
  {
    path: '/:lang?/news',
    name: 'news area',
    component: () => import(/* webpackChunkName: "news" */ '@/views/news/NewsContainer.vue'),
    children: [
      {
        path: '/:lang?/news/tags/:tagname',
        name: 'news by tag',
        component: () => import(/* webpackChunkName: "news" */ '@/views/news/NewsHome.vue'),
        props: true
      },
      {
        path: '/:lang?/news/:id/:title',
        name: 'news item',
        component: () => import(/* webpackChunkName: "news" */ '@/views/news/NewsHome.vue'),
        props: true
      },
      {
        path: '/:lang?/news',
        name: 'news home',
        component: () => import(/* webpackChunkName: "news" */ '@/views/news/NewsHome.vue')
      }
    ]
  },
  {
    path: '/:lang?/videos/tags/:tagname',
    name: 'videos by tag',
    component: () => import(/* webpackChunkName: "video" */ '@/views/videos/VideoHome.vue'),
    props: true
  },
  {
    path: '/:lang?/videos/:id/:title',
    name: 'video item',
    component: () => import(/* webpackChunkName: "video" */ '@/views/videos/VideoHome.vue'),
    props: true
  },
  {
    path: '/:lang?/videos',
    name: 'video home',
    component: () => import(/* webpackChunkName: "video" */ '@/views/videos/VideoHome.vue')
  }
]

export default illustrators